import React, {useEffect,useState} from "react";
import { Empty } from "antd";
import { useNavigate } from "react-router-dom";
import { getFieldStyle } from "../../themes.js";
import useSettingstore from "../../store/settings.store.js";
import "./rtable.scss";

export default function RTable({
    isClickable = false,
    titleList,
    data,
    isResumePage = false,
    isEditField = false,
    setCurrentView,
    resumeProfileHandler,
    jdID, 
    pullAvailableData,
    emptyString,
  restorePreviousData,
  columnWidth = [50, 100, 200, 100, 100, 100],
}) {
  const { addOrUpdateSetting, getSettingByKey } = useSettingstore();
    const navigate = useNavigate();
  // useEffect(() => {
  //   if (data?.length > 0) {
  //     pullAvailableData && pullAvailableData();

  //     return () => {
  //       restorePreviousData && restorePreviousData();
  //     };
  //   }
  // }, [titleList]);

  const SETTING_KEY = "rtable_frozen_columns";
  // Initialize state: Try to get from store first, otherwise default to 1
  const [frozenColumns, setFrozenColumns] = useState(() => {
    const saved = getSettingByKey(SETTING_KEY);
    return saved ? saved.value : 1;
  });

  const handleFreezeChange = (e) => {
    const newValue = parseInt(e.target.value) || 0;

    // Update local UI state
    setFrozenColumns(newValue);

    // Persist to Zustand Store
    addOrUpdateSetting({
      key: SETTING_KEY,
      value: newValue,
    });
  };

  
    const handleResumeDetailClick = (id,qhID) => {
        var view = "profile"
        if(resumeProfileHandler){
            resumeProfileHandler(jdID,id, qhID,)
            setCurrentView(view)
            navigate(`candidateProfile/${id}/${qhID}/${view}`, { state: { jdID: jdID } }); 
        }
    };
   const handleResumeStatsClick = (id)=>{
    navigate(id)
   }
    if ((!data) || data?.length == 0) {
        return <Empty style={{ margin: "60px" }} />;
    }
  const getStickyStyle = (index, cellType) => {
    if (index >= frozenColumns) return {};

    // Calculate sum of widths of all previous columns to set the 'left' property
    const leftOffset = columnWidth
      .slice(0, index)
      .reduce((acc, curr) => acc + curr, 0);

    return {
      position: "sticky",
      left: `${leftOffset}px`,
      zIndex: 10,
      background: cellType === "title" ? "#99d2fd" : "#c0e4ff",
      boxShadow:
        index === frozenColumns - 1 ? "2px 0 5px -2px rgba(0,0,0,0.2)" : "none", // Adds a nice shadow line
    };
  };

  const gridTemplate = columnWidth.map((w) => `${w}px`).join(" ");
  return (
    <div className="rtable-wrapper">
      <div
        className="freeze-control"
        style={{ marginBottom: "10px", position: "sticky", left: "0" }}
      >
        <span style={{ fontSize: "14px" }}>Freeze Columns: </span>
        <input
          type="number"
          min="0"
          max={titleList.length}
          value={frozenColumns}
          onChange={handleFreezeChange}
          style={{
            width: "50px",
            marginLeft: "10px",
          }}
        />
      </div>
      <div
        className="rtable-title-wrapper"
        style={{
          gridTemplateColumns: gridTemplate,
        }}
      >
        {titleList?.map((title, idx) => (
          <div className="rtable-title" style={getStickyStyle(idx, "title")}>
            {title}
          </div>
        ))}
      </div>
      {data?.map((table, rowIndex) => (
        <div
          onClick={
            isResumePage
              ? () => handleResumeDetailClick(table.id, table.qhid)
              : () => handleResumeStatsClick(table.team_member_id)
          }
          key={table.id}
          className="rtable-info-wrapper"
          style={{
            gridTemplateColumns: gridTemplate,
            cursor: isClickable && "pointer",
          }}
        >
          {Object.keys(table)?.map((tableInfo, idx) => (
            <div
              className={`rtable-info${
                tableInfo === "email" ? " rtable-info-email" : ""
              }`}
              style={{
                ...getFieldStyle(tableInfo, table[tableInfo]),
                ...getStickyStyle(idx, "info"),
              }}
            >
              {isEditField ? (
                <></>
              ) : tableInfo === "id" ? (
                rowIndex + 1
              ) : table[tableInfo] === "" ? (
                "--"
              ) : (
                table[tableInfo]
              )}
            </div>
          ))}
        </div>
      ))}
    </div>
  );
}
